import { IconButton, Typography } from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import React, { useState, useEffect } from "react";
import SiTextField from "../../core/si-textfield";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import { Icon } from "@iconify/react";
import moment from "moment";

const PastHistory = ({ onSave, pastHistory, onDelete }) => {
  const [serviceDetails, setServiceDetails] = useState({});
  const [addNew, setAddNew] = useState(false);
  const [isInvalidDate, setIsInvalidDate] = useState(false);

  const onInputChange = (event) => {
    setServiceDetails({
      ...serviceDetails,
      [event.target.name]: event.target.value,
    });
  };

  const deleteRecord = (index) => {
    pastHistory.splice(index, 1);
    onDelete([...pastHistory]);
  };

  useEffect(() => {
    const currentDate = new Date();
    const enteredDate = new Date(serviceDetails?.dateOfFailure);
    if (enteredDate > currentDate) {
      setIsInvalidDate(true);
    } else {
      setIsInvalidDate(false);
    }
  }, [serviceDetails]);

  return (
    <div>
      <div className="ph-header">
        <p className="primary-text">Past History</p>
        <IconButton onClick={() => setAddNew(true)}>
          <Icon
            icon="lets-icons:add-duotone"
            width="2rem"
            height="2rem"
            style={{ color: "#095adc" }}
          />
        </IconButton>
      </div>
      {addNew && (
        <div className="ph-row">
          <SiTextField
            name={"dateOfFailure"}
            placeholder="Date Of Failure"
            type="date"
            onChange={onInputChange}
            value={serviceDetails.dateOfFailure || ""}
            error={isInvalidDate}
            helperText={isInvalidDate && "Date cannot be in the future"}
            InputProps={{
              inputProps: { max: new Date().toISOString().split("T")[0] },
            }}
          />
          <SiTextField
            name="hours"
            placeholder="Running Hours"
            onChange={onInputChange}
            value={serviceDetails.hours || ""}
          />
          <SiTextField
            name="complaintReported"
            placeholder="Complaint Reported"
            onChange={onInputChange}
            value={serviceDetails.complaintReported || ""}
          />
          <div style={{ display: "flex", gap: "5px" }}>
            <IconButton
              disabled={
                !serviceDetails.dateOfFailure ||
                !serviceDetails.hours ||
                !serviceDetails.complaintReported ||
                isInvalidDate
              }
              onClick={() => {
                setAddNew(false);
                onSave(serviceDetails);
                setServiceDetails({});
              }}
            >
              <CheckCircleOutlineOutlinedIcon />
            </IconButton>
            <IconButton onClick={() => setAddNew(false)}>
              <CancelOutlinedIcon />
            </IconButton>
          </div>
        </div>
      )}
      <div className="ph-table">
        {pastHistory.length > 0 && (
          <div className="pst-header pht-header table-header-bg primary-text">
            <span>Date Of Failure</span>
            <span>Running Hours</span>
            <span>Complaint Reported</span>
            <span>Actions</span>
          </div>
        )}
        {pastHistory.map((item, index) => {
          return (
            <div className="pst-header pht-header">
              <span>{moment(item?.dateOfFailure).format("DD-MM-YYYY")}</span>
              <span>{item.hours}</span>
              <span>{item.complaintReported}</span>
              <div style={{ display: "flex", gap: "5px" }}>
                <IconButton
                  onClick={() => deleteRecord(index)}
                  sx={{ padding: "0px" }}
                >
                  <DeleteTwoToneIcon color="error" />
                </IconButton>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PastHistory;
